import { render, staticRenderFns } from "./ModalMore.vue?vue&type=template&id=4b819e25&scoped=true&"
import script from "./ModalMore.vue?vue&type=script&lang=js&"
export * from "./ModalMore.vue?vue&type=script&lang=js&"
import style0 from "./ModalMore.vue?vue&type=style&index=0&id=4b819e25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b819e25",
  null
  
)

export default component.exports